export default "//file.bilionpass.com/japandx-web/0.0.1/static/icon_discount_hotel.528445f0-cb2803.svg";